import { expVal } from '@confluence/feature-experiments';

import { getAgentBrand as resolveAgentBrand } from '@atlassian/do-not-use-agent-brand/get-agent-brand';

export type AgentBrand = NonNullable<ReturnType<typeof resolveAgentBrand>>;

/**
 * Applies Confluence's presence-tier rollout to the shared brand table. The shared package
 * cannot read product experiments, so the decision is made here and passed down.
 */
export const getAgentBrand = (displayName: string): AgentBrand | undefined =>
	resolveAgentBrand(displayName, {
		includePresenceBrands: expVal('dual_agent_avatar_card', 'isEnabled', false),
	});
